// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"471":"41fd79b0","744":"03a05717"}[chunkId] + ".chunk.js";
};